// Marigold app js

import { _googlemap } from './marigold/googlemap';

const mapparmas = {
  lat: 34.7634558,
  lng: 134.85806,
  zoom: 16,
  element: 'googlemap',
};

_googlemap(mapparmas);